import useSWRMutation from 'swr/mutation'

import { useAuth } from '../../context/auth'
import { errorFromResponse, ErrorType, handleUnauthorized } from './useQuery'

const API_URL = import.meta.env.VITE_API_URL

export function useDeleteMutation(path: string) {
  const authState = useAuth()

  const fetcher = async (url: string) => {
    const response = await fetch(API_URL + url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        UQRDM_TOKEN: authState?.token || '',
      },
    })

    if (!response.ok) {
      handleUnauthorized(response.status)
      throw await errorFromResponse(response, 'DELETE')
    }

    return (await response.json()) as boolean
  }

  const { trigger, isMutating, error } = useSWRMutation(path, fetcher)

  const formattedError: ErrorType | null = error
    ? { code: error.code || 'UNKNOWN', message: error.message || 'An unknown error occurred' }
    : null

  const mutate = (): Promise<boolean> => {
    return trigger()
  }

  return [mutate, { loading: isMutating, error: formattedError }] as const
}
